import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

/** FieldLabel a label for a field on a form. */
const FieldLabel = props => {
  const { id, className, children, ...other } = props;

  return (
    <label
      htmlFor={id}
      className={clsx("em-c-field__label", className)}
      {...other}
    >
      {children}
    </label>
  );
};

FieldLabel.propTypes = {
  /** children is the contents */
  children: PropTypes.node,
  /** Additional css classes to append to the outer element */
  className: PropTypes.string
};

FieldLabel.defaultProps = {
  children: null,
  className: ""
};

export default FieldLabel;
